<template>
  <div id="scheduleView" class="statv_container statv_page_bg">
    <DateView></DateView>
    <!-- <WeekView></WeekView> -->
  </div>
</template>
<script>
import Utils from "@/helpers/utils"
import moment from "moment";

import DateView from "./ScheduleDate.vue"
import WeekView from "./ScheduleWeek.vue"

export default {
  name: "Schedule",
  components: {
    DateView, WeekView
  },
  data() {
    return {
      VIEW_FLAG: false, //false: 일일편성표, true: 주간편성표
      expanded: false
    }
  },
  async created() {
    if(!Utils.isMobile()) window.addEventListener('resize', this.handleResize);
    this.handleResize();
    // this.searchDate = moment().format("YYYY-MM-DD");
    this.searchDate = this.preview === true ? this.preview_date : moment().format("YYYY-MM-DD");
  },
  beforeDestroy() {
    if(!Utils.isMobile()) window.removeEventListener('resize', this.handleResize);
  },
  watch: {

  },
  methods: {
    loadSchedules: _.debounce(async function() {
      // 버튼 클릭 후 잦은 로딩 방지 (500ms에 한 번 실행)
      let response = await this.getSchedules(this.searchDate);
      if(_.size(response) > 0 ) {
        let responseDate = response[0]['date'];
        if(!_.eq(this.searchDate, responseDate)) {
          // 선택 날짜 데이터 없으면 최근 날짜로 변경
          // this.searchDate = moment(responseDate).format("YYYY.MM.DD");
          this.searchDate = responseDate;
        } 
      }
    }, 500),
    async calcDate(o) {
      let n = moment(this.searchDate, "YYYY-MM-DD").add(o, 'd');
      this.searchDate = n.format("YYYY-MM-DD");
    },
    handleResize(e) {
      if(window.innerWidth <= Utils.getSize().MOBILE) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  },
}
</script>
<style lang="less">
.statv_page_bg {
  min-height: 0;
}
.m .statv_page_bg {
  min-height: 0;
}
#scheduleView {
  // background-image: url("~@/assets/image/home/bg_top@2x.png");
  // background-repeat: no-repeat;
  // background-size: contain;
  // background-position: left top;
  // width: 1815px;
  // min-height: 1128px;
}
</style>
